import * as React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <mask
      id="mask0_4553_95178"
      style={{ maskType: 'alpha' }}
      width="24"
      height="24"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
    </mask>
    <g mask="url(#mask0_4553_95178)">
      <path
        fill="#4024D3"
        d="M6.5 20c-1.517 0-2.813-.525-3.888-1.575C1.537 17.375 1 16.092 1 14.575c0-1.3.392-2.458 1.175-3.475S3.983 9.433 5.25 9.15c.283-1.2.992-2.342 2.125-3.425C8.508 4.642 9.717 4.1 11 4.1c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412v6.05l1.6-1.55L16 12l-4 4-4-4 1.4-1.4 1.6 1.55V6.1c-1.267.233-2.25.846-2.95 1.838C7.35 8.929 7 9.95 7 11h-.5c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 003 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 006.5 18h12c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-.8-.183-1.546-.55-2.237A5.614 5.614 0 0015 7V4.675a6.827 6.827 0 012.925 2.588A6.895 6.895 0 0119 11c1.15.133 2.104.63 2.863 1.488A4.407 4.407 0 0123 15.5c0 1.25-.438 2.313-1.313 3.188S19.75 20 18.5 20h-12z"
      ></path>
    </g>
  </svg>
);
